import { Body, Box, Divider, Heading } from '@hover/blueprint';
import React from 'react';
import { StyleProps } from '@chakra-ui/react';
import { TEAM_VALUES } from '../../../constants';
import { IAboutTeamValue } from '../../../interfaces/IAboutTeamValue';

interface Props {
  selectedValue: string;
  setSelectedValue: (value: string) => void;
}

const dividerStyles: StyleProps = {
  color: 'green.300',
  mb: { base: 500, desktop: 800 },
  borderWidth: '1px',
};

const Mobile: React.FC<Props> = ({ selectedValue, setSelectedValue }) => (
  <Box flexDir="column" display={{ base: 'block', tablet: 'none' }} px={200}>
    <Divider {...dividerStyles} />
    {TEAM_VALUES.map((teamValue: IAboutTeamValue) => (
      <React.Fragment key={teamValue.id}>
        <Heading
          as="h3"
          onClick={() => setSelectedValue(teamValue.value)}
          size={800}
          color={selectedValue === teamValue.value ? 'green.500' : 'green.100'}
        >
          {teamValue.title}
        </Heading>
        <Box
          display={selectedValue === teamValue.value ? 'block' : 'none'}
          width={{ base: '100%', desktop: 584 }}
        >
          {teamValue.image}
          <Body mt={600} size={500} maxW="584px">
            {teamValue.body}
          </Body>
        </Box>
        <Divider color="green.300" my={500} borderWidth="1px" />
      </React.Fragment>
    ))}
  </Box>
);

export default Mobile;
